import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as moduleItemActions from '../module-item/module-item.actions';
import { ModuleItem } from '../../../models/module-item';
import { ModuleItemsConfig } from '../../../models/module-items-config';

export interface ModuleItemState extends EntityState<ModuleItem> {
  loadingModuleItemsConfig: boolean;
  moduleItemsConfigLoaded: boolean;
  moduleItemsConfig: ModuleItemsConfig;
  moduleItemsSortingOrder: number[];
  savedModuleItem: ModuleItem;
  importingModuleItems: boolean;
  moduleItemsImported: boolean;
}

export const moduleItemAdapter: EntityAdapter<ModuleItem> = createEntityAdapter<ModuleItem>();

export const initialModuleItemState: ModuleItemState = moduleItemAdapter.getInitialState({
  loadingModuleItemsConfig: false,
  moduleItemsConfigLoaded: false,
  moduleItemsConfig: null,
  moduleItemsSortingOrder: [],
  savedModuleItem: null,
  importingModuleItems: false,
  moduleItemsImported: false,
});

export const reducer = createReducer(
  initialModuleItemState,
  on(moduleItemActions.setSelectedModuleItems, (state, { moduleItems }) => {
    return moduleItemAdapter.setAll(moduleItems, {
      ...state,
    });
  }),
  on(moduleItemActions.getModuleItemsConfig, (state) => {
    return {
      ...state,
      loadingModuleItemsConfig: true,
      moduleItemsConfigLoaded: false,
    };
  }),
  on(moduleItemActions.getModuleItemsConfigSuccess, (state, { moduleItemsConfig }) => {
    return {
      ...state,
      loadingModuleItemsConfig: false,
      moduleItemsConfigLoaded: true,
      moduleItemsConfig,
    };
  }),
  on(moduleItemActions.getModuleItemsConfigError, (state) => {
    return {
      ...state,
      loadingModuleItemsConfig: false,
      moduleItemsConfigLoaded: true,
    };
  }),
  on(moduleItemActions.createModuleItemSuccess, (state, { newModuleItem }) => {
    return moduleItemAdapter.addOne(newModuleItem, {
      ...state,
      savedModuleItem: newModuleItem,
    });
  }),
  on(moduleItemActions.updateModuleItemSuccess, (state, { updatedModuleItem }) => {
    return moduleItemAdapter.updateOne(
      { id: updatedModuleItem.id, changes: updatedModuleItem },
      {
        ...state,
        savedModuleItem: updatedModuleItem,
      }
    );
  }),
  on(moduleItemActions.deleteModuleItemSuccess, (state, { deletedModuleItemId }) => {
    return moduleItemAdapter.removeOne(deletedModuleItemId, {
      ...state,
    });
  }),
  on(moduleItemActions.saveModuleItemSortingOrderSuccess, (state, { sortingOrder }) => {
    return {
      ...state,
      moduleItemsSortingOrder: sortingOrder,
    };
  }),
  on(moduleItemActions.importModuleItems, (state) => {
    return {
      ...state,
      importingModuleItems: true,
      moduleItemsImported: false,
    };
  }),
  on(moduleItemActions.importModuleItemsSuccess, (state, { importedModuleItems }) => {
    return moduleItemAdapter.addMany(importedModuleItems?.items, {
      ...state,
      importingModuleItems: false,
      moduleItemsImported: true,
    });
  }),
  on(moduleItemActions.importModuleItemsError, (state) => {
    return {
      ...state,
      importingModuleItems: false,
      moduleItemsImported: false,
    };
  })
);

export function moduleItemReducer(state: ModuleItemState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = moduleItemAdapter.getSelectors();
